import React from 'react';

const ProfileIcon = ({ colorFill = "#000000" }: { colorFill?: string }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 9C11.4853 9 13.5 6.98528 13.5 4.5C13.5 2.01472 11.4853 0 9 0C6.51472 0 4.5 2.01472 4.5 4.5C4.5 6.98528 6.51472 9 9 9Z" fill={colorFill}/>
            <path d="M9 10.5C5.27379 10.5041 2.25415 13.5238 2.25 17.25C2.25 17.6642 2.58578 18 2.99999 18H15C15.4142 18 15.75 17.6642 15.75 17.25C15.7458 13.5238 12.7262 10.5041 9 10.5Z" fill={colorFill}/>
        </svg>

    )
};

export default ProfileIcon;